<template>
    <div>
        <loading v-if="loading_status" />

        <div class="contenedor-flexible">

            <iframe ref="iframe" id="iframe" @load="onIframeLoaded" v-show="user.user_id" :src="iframeSrc"
                sandbox="allow-scripts allow-popups allow-forms allow-top-navigation allow-same-origin"></iframe>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        cliente_id: Number,
    },
    data() {
        return {
            iframeSrc: '',
            loading_status: true,
        }
    },
    computed: {
        ...mapState('user', ['user'])
    },
    mounted() {


        let link = window.location.origin.replace('app', 'chat');


        link = `${link}/rooms`;
        this.iframeSrc = `${link}/${this.user.user_id}/${window.btoa(this.user.email)}`;
        if (this.cliente_id){
            link = window.location.origin.replace('app', 'chat');
            link = `${link}/tarefa`;; // definir o src do iframe com a mesma origem do cookie

        this.iframeSrc = `${link}/${this.user.user_id}/${window.btoa(this.user.email)}/${this.cliente_id}`;
        }

    },
    methods: {
        onIframeLoaded() {
            this.loading_status = false;
        }
    },
    beforeDestroy() {
        const iframe = document.getElementById('iframe');
        if (iframe && iframe.parentNode) {

            iframe.parentNode.removeChild(iframe);
        }
    }
}
</script>
<style>
.contenedor-flexible {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 85vh;
}

.contenedor-flexible iframe {
    width: 100%;
    height: 100%;
    border: none;
}
</style>
